import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object  } from 'yup';
import RegistrationLinkForm from '../Layouts/RegistrationLinkForm'; 
import { useAddRegistrationLinkMutation } from 'src/services/RegistrationLinkServices';
import { showToast } from 'src/utils/showToaster';

export  type RegistrationLinkFormValues  ={
    batchId :any ;
}

type Props = {
  onClose: () => void;
};

const AddRegistrationLinkFormWrapper = ({ onClose }: Props) => { 

 const [addRegistration] = useAddRegistrationLinkMutation()

  // Form Initial Values
  const initialValues: RegistrationLinkFormValues = {
    batchId :'',
  };

  // Validation Schema
  const validationSchema = object().shape({
    batchId: object().required('Please select batch'),
  });

  // Handle Submit
  const handleSubmit = (
    values: RegistrationLinkFormValues,
    { setSubmitting, resetForm }: FormikHelpers<RegistrationLinkFormValues>
  ) => { 
    const formattedValues = {
        batchId : values?.batchId?.value
    }
    addRegistration(formattedValues).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <RegistrationLinkForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddRegistrationLinkFormWrapper;